import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=615459cb"
import script from "./Storage.ts?vue&type=script&lang=ts&external"
export * from "./Storage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports